import React, { useEffect } from "react";
import { createPortal } from "react-dom";
import "./Toast.css";

const AUTO_HIDE_MS = 7000;

/** Уведомление внизу экрана; toast — { id, title, text, actionLabel, onAction } */
function Toast({ toast, onClose }) {
  useEffect(() => {
    if (!toast) return undefined;
    const timer = setTimeout(onClose, AUTO_HIDE_MS);
    return () => clearTimeout(timer);
  }, [toast, onClose]);

  if (!toast) return null;

  return createPortal(
    <div key={toast.id} className="rr-toast" role="status">
      <span className="rr-toast__icon">
        <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
          <path
            d="M2.5 6.2l2.3 2.3 4.7-5"
            stroke="currentColor"
            strokeWidth="1.6"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </span>
      <div className="rr-toast__content">
        <div className="rr-toast__title">{toast.title}</div>
        {toast.text && <div className="rr-toast__text">{toast.text}</div>}
      </div>
      {toast.actionLabel && (
        <button type="button" className="rr-toast__action" onClick={toast.onAction}>
          {toast.actionLabel}
        </button>
      )}
      <button type="button" className="rr-toast__close" aria-label="Закрыть" onClick={onClose}>
        <svg width="10" height="10" viewBox="0 0 10 10" fill="none">
          <path d="M1.5 1.5l7 7M8.5 1.5l-7 7" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" />
        </svg>
      </button>
    </div>,
    document.body
  );
}

export default Toast;
